var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGatewayPatternTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 401,
    viewBox: "0 0 308 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6997 -51.9912L37.1812 -70.2224L21.6037 -54.8836L28.3603 -48.2313L37.1812 -56.9155L42.1819 -51.9912L25.4215 -35.488L8.66343 -51.9912L25.4215 -68.4944L28.1498 -65.8078L34.9087 -72.4647L25.4215 -81.8013L-4.85198 -51.9912L25.4215 -22.1765L55.6997 -51.9912Z",
    fill: "url(#paint0_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77 -51.9912L108.251 -70.2224L92.6736 -54.8836L99.4325 -48.2313L108.251 -56.9155L113.252 -51.9912L96.4937 -35.488L79.7333 -51.9912L96.4937 -68.4944L99.2221 -65.8078L105.979 -72.4647L96.4937 -81.8013L66.2179 -51.9912L96.4937 -22.1765L126.77 -51.9912Z",
    fill: "url(#paint1_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.643 -52.1899L179.125 -70.4211L163.547 -55.0823L170.304 -48.4277L179.125 -57.1143L184.125 -52.1899L167.367 -35.6867L150.607 -52.1899L167.367 -68.6932L170.096 -66.0065L176.852 -72.6635L167.367 -82L137.091 -52.1899L167.367 -22.3752L197.643 -52.1899Z",
    fill: "url(#paint2_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.517 -51.9912L249.998 -70.2224L234.421 -54.8836L241.177 -48.2313L249.998 -56.9155L254.999 -51.9912L238.238 -35.488L221.48 -51.9912L238.238 -68.4944L240.967 -65.8078L247.726 -72.4647L238.238 -81.8013L207.965 -51.9912L238.238 -22.1765L268.517 -51.9912Z",
    fill: "url(#paint3_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.586 -51.9912L321.068 -70.2224L305.491 -54.8836L312.247 -48.2313L321.068 -56.9155L326.069 -51.9912L309.311 -35.488L292.55 -51.9912L309.311 -68.4944L312.039 -65.8078L318.795 -72.4647L309.311 -81.8013L279.035 -51.9912L309.311 -22.1765L339.586 -51.9912Z",
    fill: "url(#paint4_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.46 -52.1899L391.941 -70.4211L376.364 -55.0823L383.121 -48.4277L391.941 -57.1143L396.942 -52.1899L380.182 -35.6867L363.424 -52.1899L380.182 -68.6932L382.91 -66.0065L389.669 -72.6635L380.182 -82L349.908 -52.1899L380.182 -22.3752L410.46 -52.1899Z",
    fill: "url(#paint5_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.333 -51.9912L462.813 -70.2224L447.235 -54.8836L453.994 -48.2313L462.813 -56.9155L467.816 -51.9912L451.055 -35.488L434.295 -51.9912L451.055 -68.4944L453.784 -65.8078L460.54 -72.4647L451.055 -81.8013L420.782 -51.9912L451.055 -22.1765L481.333 -51.9912Z",
    fill: "url(#paint6_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.403 -51.9912L533.885 -70.2224L518.307 -54.8836L525.064 -48.2313L533.885 -56.9155L538.886 -51.9912L522.125 -35.488L505.367 -51.9912L522.125 -68.4944L524.854 -65.8078L531.612 -72.4647L522.125 -81.8013L491.852 -51.9912L522.125 -22.1765L552.403 -51.9912Z",
    fill: "url(#paint7_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.277 -52.1899L604.756 -70.4211L589.179 -55.0823L595.937 -48.4277L604.756 -57.1143L609.759 -52.1899L592.999 -35.6867L576.238 -52.1899L592.999 -68.6932L595.727 -66.0065L602.484 -72.6635L592.999 -82L562.725 -52.1899L592.999 -22.3752L623.277 -52.1899Z",
    fill: "url(#paint8_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5517 -13.3754L2.03314 -31.6065L-13.5443 -16.2678L-6.78777 -9.61317L2.03314 -18.2997L7.03391 -13.3754L-9.72651 3.12783L-26.4846 -13.3754L-9.72651 -29.8786L-6.99817 -27.192L-0.2393 -33.8489L-9.72651 -43.1854L-40 -13.3754L-9.72651 16.4394L20.5517 -13.3754Z",
    fill: "url(#paint9_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.724 16.4394L659 -13.3754L640.481 -31.6065L624.904 -16.2678L631.661 -9.61317L640.481 -18.2997L645.482 -13.3754L628.724 3.12783L611.964 -13.3754L628.724 -29.8786L631.453 -27.192L638.209 -33.8489L628.724 -43.1854L598.448 -13.3754L628.724 16.4394Z",
    fill: "url(#paint10_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3457 16.4394L91.6216 -13.3754L73.103 -31.6065L57.5256 -16.2678L64.2845 -9.61317L73.103 -18.2997L78.1038 -13.3754L61.3457 3.12783L44.5853 -13.3754L61.3457 -29.8786L64.0741 -27.192L70.8306 -33.8489L61.3457 -43.1854L31.0699 -13.3754L61.3457 16.4394Z",
    fill: "url(#paint11_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.217 16.2406L162.495 -13.5718L143.977 -31.8053L128.399 -16.4665L135.156 -9.81192L143.977 -18.4961L148.977 -13.5718L132.217 2.93142L115.459 -13.5718L132.217 -30.075L134.945 -27.3884L141.704 -34.0453L132.217 -43.3842L101.943 -13.5718L132.217 16.2406Z",
    fill: "url(#paint12_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.09 16.4394L233.369 -13.3754L214.85 -31.6065L199.273 -16.2678L206.029 -9.61317L214.85 -18.2997L219.851 -13.3754L203.09 3.12783L186.33 -13.3754L203.09 -29.8786L205.819 -27.192L212.578 -33.8489L203.09 -43.1854L172.817 -13.3754L203.09 16.4394Z",
    fill: "url(#paint13_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.163 16.4394L304.438 -13.3754L285.92 -31.6065L270.342 -16.2678L277.099 -9.61317L285.92 -18.2997L290.921 -13.3754L274.163 3.12783L257.402 -13.3754L274.163 -29.8786L276.889 -27.192L283.647 -33.8489L274.163 -43.1854L243.887 -13.3754L274.163 16.4394Z",
    fill: "url(#paint14_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.034 16.2406L375.312 -13.5718L356.793 -31.8053L341.216 -16.4665L347.973 -9.81192L356.793 -18.4961L361.794 -13.5718L345.034 2.93142L328.273 -13.5718L345.034 -30.075L347.762 -27.3884L354.521 -34.0453L345.034 -43.3842L314.76 -13.5718L345.034 16.2406Z",
    fill: "url(#paint15_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.907 16.4394L446.183 -13.3754L427.665 -31.6065L412.087 -16.2678L418.846 -9.61317L427.665 -18.2997L432.665 -13.3754L415.907 3.12783L399.147 -13.3754L415.907 -29.8786L418.636 -27.192L425.392 -33.8489L415.907 -43.1854L385.631 -13.3754L415.907 16.4394Z",
    fill: "url(#paint16_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.977 16.4394L517.255 -13.3754L498.737 -31.6065L483.159 -16.2678L489.916 -9.61317L498.737 -18.2997L503.738 -13.3754L486.977 3.12783L470.219 -13.3754L486.977 -29.8786L489.705 -27.192L496.464 -33.8489L486.977 -43.1854L456.704 -13.3754L486.977 16.4394Z",
    fill: "url(#paint17_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.851 16.2406L588.126 -13.5718L569.608 -31.8053L554.031 -16.4665L560.789 -9.81192L569.608 -18.4961L574.609 -13.5718L557.851 2.93142L541.09 -13.5718L557.851 -30.075L560.579 -27.3884L567.336 -34.0453L557.851 -43.3842L527.575 -13.5718L557.851 16.2406Z",
    fill: "url(#paint18_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66343 25.1469L25.4215 8.64371L28.1498 11.3303L34.9087 4.67339L25.4215 -4.66315L-4.85198 25.1469L25.4215 54.9616L55.6997 25.1469L37.1812 6.91575L21.6037 22.2545L28.3603 28.9068L37.1812 20.2226L42.1819 25.1469L25.4215 41.6501L8.66343 25.1469Z",
    fill: "url(#paint19_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7333 25.1469L96.4937 8.64371L99.2221 11.3303L105.979 4.67339L96.4937 -4.66315L66.2179 25.1469L96.4937 54.9616L126.77 25.1469L108.251 6.91575L92.6736 22.2545L99.4325 28.9068L108.251 20.2226L113.252 25.1469L96.4937 41.6501L79.7333 25.1469Z",
    fill: "url(#paint20_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.607 24.9482L167.367 8.4473L170.096 11.1339L176.852 4.47698L167.367 -4.86189L137.091 24.9482L167.367 54.7629L197.643 24.9482L179.125 6.71701L163.547 22.0558L170.304 28.7104L179.125 20.0238L184.125 24.9482L167.367 41.4514L150.607 24.9482Z",
    fill: "url(#paint21_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48 25.1469L238.238 8.64371L240.967 11.3303L247.726 4.67339L238.238 -4.66315L207.965 25.1469L238.238 54.9616L268.517 25.1469L249.998 6.91575L234.421 22.2545L241.177 28.9068L249.998 20.2226L254.999 25.1469L238.238 41.6501L221.48 25.1469Z",
    fill: "url(#paint22_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55 25.1469L309.311 8.64371L312.039 11.3303L318.795 4.67339L309.311 -4.66315L279.035 25.1469L309.311 54.9616L339.586 25.1469L321.068 6.91575L305.491 22.2545L312.247 28.9068L321.068 20.2226L326.069 25.1469L309.311 41.6501L292.55 25.1469Z",
    fill: "url(#paint23_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.424 24.9482L380.182 8.4473L382.91 11.1339L389.669 4.47698L380.182 -4.86189L349.908 24.9482L380.182 54.7629L410.46 24.9482L391.941 6.71701L376.364 22.0558L383.121 28.7104L391.941 20.0238L396.942 24.9482L380.182 41.4514L363.424 24.9482Z",
    fill: "url(#paint24_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.295 25.1469L451.055 8.64371L453.784 11.3303L460.54 4.67339L451.055 -4.66315L420.782 25.1469L451.055 54.9616L481.333 25.1469L462.813 6.91575L447.235 22.2545L453.994 28.9068L462.813 20.2226L467.816 25.1469L451.055 41.6501L434.295 25.1469Z",
    fill: "url(#paint25_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.367 25.1469L522.125 8.64371L524.854 11.3303L531.612 4.67339L522.125 -4.66315L491.852 25.1469L522.125 54.9616L552.403 25.1469L533.885 6.91575L518.307 22.2545L525.064 28.9068L533.885 20.2226L538.886 25.1469L522.125 41.6501L505.367 25.1469Z",
    fill: "url(#paint26_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.756 6.71701L589.179 22.0558L595.937 28.7104L604.756 20.0238L609.759 24.9482L592.999 41.4514L576.238 24.9482L592.999 8.4473L595.727 11.1339L602.484 4.47698L592.999 -4.86189L562.725 24.9482L592.999 54.7629L623.277 24.9482L604.756 6.71701Z",
    fill: "url(#paint27_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5517 63.7627L2.03314 45.5316L-13.5443 60.8703L-6.78777 67.5249L2.03314 58.8384L7.03391 63.7627L-9.72651 80.2659L-26.4846 63.7627L-9.72651 47.2595L-6.99817 49.9461L-0.2393 43.2916L-9.72651 33.9527L-40 63.7627L-9.72651 93.5775L20.5517 63.7627Z",
    fill: "url(#paint28_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.904 60.8703L631.661 67.5249L640.481 58.8384L645.482 63.7627L628.724 80.2659L611.964 63.7627L628.724 47.2595L631.453 49.9461L638.209 43.2916L628.724 33.9527L598.448 63.7627L628.724 93.5775L659 63.7627L640.481 45.5316L624.904 60.8703Z",
    fill: "url(#paint29_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0699 63.7627L61.3457 93.5775L91.6216 63.7627L73.103 45.5316L57.5256 60.8703L64.2845 67.5249L73.103 58.8384L78.1038 63.7627L61.3457 80.2659L44.5853 63.7627L61.3457 47.2595L64.0741 49.9461L70.8306 43.2916L61.3457 33.9527L31.0699 63.7627Z",
    fill: "url(#paint30_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.943 63.5663L132.217 93.3787L162.495 63.5663L143.977 45.3328L128.399 60.6716L135.156 67.3262L143.977 58.642L148.977 63.5663L132.217 80.0695L115.459 63.5663L132.217 47.0631L134.945 49.7497L141.704 43.0928L132.217 33.7539L101.943 63.5663Z",
    fill: "url(#paint31_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.817 63.7627L203.09 93.5775L233.369 63.7627L214.85 45.5316L199.273 60.8703L206.029 67.5249L214.85 58.8384L219.851 63.7627L203.09 80.2659L186.33 63.7627L203.09 47.2595L205.819 49.9461L212.578 43.2916L203.09 33.9527L172.817 63.7627Z",
    fill: "url(#paint32_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.887 63.7627L274.163 93.5775L304.438 63.7627L285.92 45.5316L270.342 60.8703L277.099 67.5249L285.92 58.8384L290.921 63.7627L274.163 80.2659L257.402 63.7627L274.163 47.2595L276.889 49.9461L283.647 43.2916L274.163 33.9527L243.887 63.7627Z",
    fill: "url(#paint33_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76 63.5663L345.034 93.3787L375.312 63.5663L356.793 45.3328L341.216 60.6716L347.973 67.3262L356.793 58.642L361.794 63.5663L345.034 80.0695L328.273 63.5663L345.034 47.0631L347.762 49.7497L354.521 43.0928L345.034 33.7539L314.76 63.5663Z",
    fill: "url(#paint34_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.631 63.7627L415.907 93.5775L446.183 63.7627L427.665 45.5316L412.087 60.8703L418.846 67.5249L427.665 58.8384L432.665 63.7627L415.907 80.2659L399.147 63.7627L415.907 47.2595L418.636 49.9461L425.392 43.2916L415.907 33.9527L385.631 63.7627Z",
    fill: "url(#paint35_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.704 63.7627L486.977 93.5775L517.255 63.7627L498.737 45.5316L483.159 60.8703L489.916 67.5249L498.737 58.8384L503.738 63.7627L486.977 80.2659L470.219 63.7627L486.977 47.2595L489.705 49.9461L496.464 43.2916L486.977 33.9527L456.704 63.7627Z",
    fill: "url(#paint36_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.09 63.5663L557.851 47.0631L560.579 49.7497L567.336 43.0928L557.851 33.7539L527.575 63.5663L557.851 93.3787L588.126 63.5663L569.608 45.3328L554.031 60.6716L560.789 67.3262L569.608 58.642L574.609 63.5663L557.851 80.0695L541.09 63.5663Z",
    fill: "url(#paint37_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4215 132.298L55.6997 102.484L37.1812 84.2503L21.6037 99.589L28.3603 106.244L37.1812 97.5594L42.1819 102.484L25.4215 118.987L8.66343 102.484L25.4215 85.9805L28.1498 88.6672L34.9087 82.0103L25.4215 72.6737L-4.85198 102.484L25.4215 132.298Z",
    fill: "url(#paint38_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7333 102.484L96.4937 85.9805L99.2221 88.6672L105.979 82.0103L96.4937 72.6737L66.2179 102.484L96.4937 132.298L126.77 102.484L108.251 84.2503L92.6736 99.589L99.4325 106.244L108.251 97.5594L113.252 102.484L96.4937 118.987L79.7333 102.484Z",
    fill: "url(#paint39_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.607 102.285L167.367 85.7818L170.096 88.4684L176.852 81.8115L167.367 72.475L137.091 102.285L167.367 132.1L197.643 102.285L179.125 84.0538L163.547 99.3926L170.304 106.045L179.125 97.3607L184.125 102.285L167.367 118.788L150.607 102.285Z",
    fill: "url(#paint40_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48 102.484L238.238 85.9805L240.967 88.6672L247.726 82.0103L238.238 72.6737L207.965 102.484L238.238 132.298L268.517 102.484L249.998 84.2503L234.421 99.589L241.177 106.244L249.998 97.5594L254.999 102.484L238.238 118.987L221.48 102.484Z",
    fill: "url(#paint41_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55 102.484L309.311 85.9805L312.039 88.6672L318.795 82.0103L309.311 72.6737L279.035 102.484L309.311 132.298L339.586 102.484L321.068 84.2503L305.491 99.589L312.247 106.244L321.068 97.5594L326.069 102.484L309.311 118.987L292.55 102.484Z",
    fill: "url(#paint42_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.424 102.285L380.182 85.7818L382.91 88.4684L389.669 81.8115L380.182 72.475L349.908 102.285L380.182 132.1L410.46 102.285L391.941 84.0538L376.364 99.3926L383.121 106.045L391.941 97.3607L396.942 102.285L380.182 118.788L363.424 102.285Z",
    fill: "url(#paint43_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.295 102.484L451.055 85.9805L453.784 88.6672L460.54 82.0103L451.055 72.6737L420.782 102.484L451.055 132.298L481.333 102.484L462.813 84.2503L447.235 99.589L453.994 106.244L462.813 97.5594L467.816 102.484L451.055 118.987L434.295 102.484Z",
    fill: "url(#paint44_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.367 102.484L522.125 85.9805L524.854 88.6672L531.612 82.0103L522.125 72.6737L491.852 102.484L522.125 132.298L552.403 102.484L533.885 84.2503L518.307 99.589L525.064 106.244L533.885 97.5594L538.886 102.484L522.125 118.987L505.367 102.484Z",
    fill: "url(#paint45_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.238 102.285L592.999 85.7818L595.727 88.4684L602.484 81.8115L592.999 72.475L562.725 102.285L592.999 132.1L623.277 102.285L604.756 84.0538L589.179 99.3926L595.937 106.045L604.756 97.3607L609.759 102.285L592.999 118.788L576.238 102.285Z",
    fill: "url(#paint46_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5517 141.1L2.03314 122.868L-13.5443 138.207L-6.78777 144.859L2.03314 136.175L7.03391 141.1L-9.72651 157.603L-26.4846 141.1L-9.72651 124.596L-6.99817 127.283L-0.2393 120.626L-9.72651 111.29L-40 141.1L-9.72651 170.914L20.5517 141.1Z",
    fill: "url(#paint47_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.904 138.207L631.661 144.859L640.481 136.175L645.482 141.1L628.724 157.603L611.964 141.1L628.724 124.596L631.453 127.283L638.209 120.626L628.724 111.29L598.448 141.1L628.724 170.914L659 141.1L640.481 122.868L624.904 138.207Z",
    fill: "url(#paint48_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0699 141.1L61.3457 170.914L91.6216 141.1L73.103 122.868L57.5256 138.207L64.2845 144.859L73.103 136.175L78.1038 141.1L61.3457 157.603L44.5853 141.1L61.3457 124.596L64.0741 127.283L70.8306 120.626L61.3457 111.29L31.0699 141.1Z",
    fill: "url(#paint49_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.943 140.901L132.217 170.716L162.495 140.901L143.977 122.67L128.399 138.008L135.156 144.663L143.977 135.977L148.977 140.901L132.217 157.404L115.459 140.901L132.217 124.4L134.945 127.087L141.704 120.43L132.217 111.091L101.943 140.901Z",
    fill: "url(#paint50_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.817 141.1L203.09 170.914L233.369 141.1L214.85 122.868L199.273 138.207L206.029 144.859L214.85 136.175L219.851 141.1L203.09 157.603L186.33 141.1L203.09 124.596L205.819 127.283L212.578 120.626L203.09 111.29L172.817 141.1Z",
    fill: "url(#paint51_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.887 141.1L274.163 170.914L304.438 141.1L285.92 122.868L270.342 138.207L277.099 144.859L285.92 136.175L290.921 141.1L274.163 157.603L257.402 141.1L274.163 124.596L276.889 127.283L283.647 120.626L274.163 111.29L243.887 141.1Z",
    fill: "url(#paint52_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76 140.901L345.034 170.716L375.312 140.901L356.793 122.67L341.216 138.008L347.973 144.663L356.793 135.977L361.794 140.901L345.034 157.404L328.273 140.901L345.034 124.4L347.762 127.087L354.521 120.43L345.034 111.091L314.76 140.901Z",
    fill: "url(#paint53_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.631 141.1L415.907 170.914L446.183 141.1L427.665 122.868L412.087 138.207L418.846 144.859L427.665 136.175L432.665 141.1L415.907 157.603L399.147 141.1L415.907 124.596L418.636 127.283L425.392 120.626L415.907 111.29L385.631 141.1Z",
    fill: "url(#paint54_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.704 141.1L486.977 170.914L517.255 141.1L498.737 122.868L483.159 138.207L489.916 144.859L498.737 136.175L503.738 141.1L486.977 157.603L470.219 141.1L486.977 124.596L489.705 127.283L496.464 120.626L486.977 111.29L456.704 141.1Z",
    fill: "url(#paint55_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.09 140.901L557.851 124.4L560.579 127.087L567.336 120.43L557.851 111.091L527.575 140.901L557.851 170.716L588.126 140.901L569.608 122.67L554.031 138.008L560.789 144.663L569.608 135.977L574.609 140.901L557.851 157.404L541.09 140.901Z",
    fill: "url(#paint56_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4215 209.437L55.6997 179.622L37.1812 161.388L21.6037 176.727L28.3603 183.382L37.1812 174.698L42.1819 179.622L25.4215 196.125L8.66343 179.622L25.4215 163.119L28.1498 165.805L34.9087 159.148L25.4215 149.812L-4.85198 179.622L25.4215 209.437Z",
    fill: "url(#paint57_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7333 179.622L96.4937 163.119L99.2221 165.805L105.979 159.148L96.4937 149.812L66.2179 179.622L96.4937 209.437L126.77 179.622L108.251 161.388L92.6736 176.727L99.4325 183.382L108.251 174.698L113.252 179.622L96.4937 196.125L79.7333 179.622Z",
    fill: "url(#paint58_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.607 179.423L167.367 162.92L170.096 165.607L176.852 158.95L167.367 149.613L137.091 179.423L167.367 209.238L197.643 179.423L179.125 161.192L163.547 176.531L170.304 183.183L179.125 174.499L184.125 179.423L167.367 195.926L150.607 179.423Z",
    fill: "url(#paint59_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.48 179.622L238.238 163.119L240.967 165.805L247.726 159.148L238.238 149.812L207.965 179.622L238.238 209.437L268.517 179.622L249.998 161.388L234.421 176.727L241.177 183.382L249.998 174.698L254.999 179.622L238.238 196.125L221.48 179.622Z",
    fill: "url(#paint60_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.55 179.622L309.311 163.119L312.039 165.805L318.795 159.148L309.311 149.812L279.035 179.622L309.311 209.437L339.586 179.622L321.068 161.388L305.491 176.727L312.247 183.382L321.068 174.698L326.069 179.622L309.311 196.125L292.55 179.622Z",
    fill: "url(#paint61_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.424 179.423L380.182 162.92L382.91 165.607L389.669 158.95L380.182 149.613L349.908 179.423L380.182 209.238L410.46 179.423L391.941 161.192L376.364 176.531L383.121 183.183L391.941 174.499L396.942 179.423L380.182 195.926L363.424 179.423Z",
    fill: "url(#paint62_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.295 179.622L451.055 163.119L453.784 165.805L460.54 159.148L451.055 149.812L420.782 179.622L451.055 209.437L481.333 179.622L462.813 161.388L447.235 176.727L453.994 183.382L462.813 174.698L467.816 179.622L451.055 196.125L434.295 179.622Z",
    fill: "url(#paint63_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.367 179.622L522.125 163.119L524.854 165.805L531.612 159.148L522.125 149.812L491.852 179.622L522.125 209.437L552.403 179.622L533.885 161.388L518.307 176.727L525.064 183.382L533.885 174.698L538.886 179.622L522.125 196.125L505.367 179.622Z",
    fill: "url(#paint64_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.238 179.423L592.999 162.92L595.727 165.607L602.484 158.95L592.999 149.613L562.725 179.423L592.999 209.238L623.277 179.423L604.756 161.192L589.179 176.531L595.937 183.183L604.756 174.499L609.759 179.423L592.999 195.926L576.238 179.423Z",
    fill: "url(#paint65_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5517 218.238L2.03314 200.007L-13.5443 215.345L-6.78777 221.998L2.03314 213.313L7.03391 218.238L-9.72651 234.741L-26.4846 218.238L-9.72651 201.734L-6.99817 204.421L-0.2393 197.764L-9.72651 188.428L-40 218.238L-9.72651 248.052L20.5517 218.238Z",
    fill: "url(#paint66_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.904 215.345L631.661 221.998L640.481 213.313L645.482 218.238L628.724 234.741L611.964 218.238L628.724 201.734L631.453 204.421L638.209 197.764L628.724 188.428L598.448 218.238L628.724 248.052L659 218.238L640.481 200.007L624.904 215.345Z",
    fill: "url(#paint67_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3457 248.052L91.6216 218.238L73.103 200.007L57.5256 215.345L64.2845 221.998L73.103 213.313L78.1038 218.238L61.3457 234.741L44.5853 218.238L61.3457 201.734L64.0741 204.421L70.8306 197.764L61.3457 188.428L31.0699 218.238L61.3457 248.052Z",
    fill: "url(#paint68_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.943 218.041L132.217 247.854L162.495 218.041L143.977 199.808L128.399 215.147L135.156 221.801L143.977 213.115L148.977 218.041L132.217 234.542L115.459 218.041L132.217 201.538L134.945 204.225L141.704 197.568L132.217 188.229L101.943 218.041Z",
    fill: "url(#paint69_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.817 218.238L203.09 248.052L233.369 218.238L214.85 200.007L199.273 215.345L206.029 221.998L214.85 213.313L219.851 218.238L203.09 234.741L186.33 218.238L203.09 201.734L205.819 204.421L212.578 197.764L203.09 188.428L172.817 218.238Z",
    fill: "url(#paint70_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.887 218.238L274.163 248.052L304.438 218.238L285.92 200.007L270.342 215.345L277.099 221.998L285.92 213.313L290.921 218.238L274.163 234.741L257.402 218.238L274.163 201.734L276.889 204.421L283.647 197.764L274.163 188.428L243.887 218.238Z",
    fill: "url(#paint71_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.76 218.041L345.034 247.854L375.312 218.041L356.793 199.808L341.216 215.147L347.973 221.801L356.793 213.115L361.794 218.041L345.034 234.542L328.273 218.041L345.034 201.538L347.762 204.225L354.521 197.568L345.034 188.229L314.76 218.041Z",
    fill: "url(#paint72_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.631 218.238L415.907 248.052L446.183 218.238L427.665 200.007L412.087 215.345L418.846 221.998L427.665 213.313L432.665 218.238L415.907 234.741L399.147 218.238L415.907 201.734L418.636 204.421L425.392 197.764L415.907 188.428L385.631 218.238Z",
    fill: "url(#paint73_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.219 218.238L486.977 201.734L489.705 204.421L496.464 197.764L486.977 188.428L456.704 218.238L486.977 248.052L517.255 218.238L498.737 200.007L483.159 215.345L489.916 221.998L498.737 213.313L503.738 218.238L486.977 234.741L470.219 218.238Z",
    fill: "url(#paint74_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.09 218.041L557.851 201.538L560.579 204.225L567.336 197.568L557.851 188.229L527.575 218.041L557.851 247.854L588.126 218.041L569.608 199.808L554.031 215.147L560.789 221.801L569.608 213.115L574.609 218.041L557.851 234.542L541.09 218.041Z",
    fill: "url(#paint75_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4215 286.771L55.6997 256.959L37.1812 238.725L21.6037 254.064L28.3603 260.719L37.1812 252.034L42.1819 256.959L25.4215 273.462L8.66343 256.959L25.4215 240.456L28.1498 243.142L34.9087 236.485L25.4215 227.146L-4.85198 256.959L25.4215 286.771Z",
    fill: "url(#paint76_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4937 286.771L126.77 256.959L108.251 238.725L92.6736 254.064L99.4325 260.719L108.251 252.034L113.252 256.959L96.4937 273.462L79.7333 256.959L96.4937 240.456L99.2221 243.142L105.979 236.485L96.4937 227.146L66.2179 256.959L96.4937 286.771Z",
    fill: "url(#paint77_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.643 256.76L179.125 238.526L163.547 253.868L170.304 260.52L179.125 251.836L184.125 256.76L167.367 273.263L150.607 256.76L167.367 240.257L170.096 242.943L176.852 236.286L167.367 226.95L137.091 256.76L167.367 286.575L197.643 256.76Z",
    fill: "url(#paint78_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.517 256.959L249.998 238.725L234.421 254.064L241.177 260.719L249.998 252.034L254.999 256.959L238.238 273.462L221.48 256.959L238.238 240.456L240.967 243.142L247.726 236.485L238.238 227.146L207.965 256.959L238.238 286.771L268.517 256.959Z",
    fill: "url(#paint79_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.586 256.959L321.068 238.725L305.491 254.064L312.247 260.719L321.068 252.034L326.069 256.959L309.311 273.462L292.55 256.959L309.311 240.456L312.039 243.142L318.795 236.485L309.311 227.146L279.035 256.959L309.311 286.771L339.586 256.959Z",
    fill: "url(#paint80_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.46 256.76L391.941 238.526L376.364 253.868L383.121 260.52L391.941 251.836L396.942 256.76L380.182 273.263L363.424 256.76L380.182 240.257L382.91 242.943L389.669 236.286L380.182 226.95L349.908 256.76L380.182 286.575L410.46 256.76Z",
    fill: "url(#paint81_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.333 256.959L462.813 238.725L447.235 254.064L453.994 260.719L462.813 252.034L467.816 256.959L451.055 273.462L434.295 256.959L451.055 240.456L453.784 243.142L460.54 236.485L451.055 227.146L420.782 256.959L451.055 286.771L481.333 256.959Z",
    fill: "url(#paint82_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.367 256.959L522.125 240.456L524.854 243.142L531.612 236.485L522.125 227.146L491.852 256.959L522.125 286.771L552.403 256.959L533.885 238.725L518.307 254.064L525.064 260.719L533.885 252.034L538.886 256.959L522.125 273.462L505.367 256.959Z",
    fill: "url(#paint83_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.238 256.76L592.999 240.257L595.727 242.943L602.484 236.286L592.999 226.95L562.725 256.76L592.999 286.575L623.277 256.76L604.756 238.526L589.179 253.868L595.937 260.52L604.756 251.836L609.759 256.76L592.999 273.263L576.238 256.76Z",
    fill: "url(#paint84_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5517 295.575L2.03314 277.341L-13.5443 292.682L-6.78777 299.334L2.03314 290.65L7.03391 295.575L-9.72651 312.078L-26.4846 295.575L-9.72651 279.071L-6.99817 281.758L-0.2393 275.101L-9.72651 265.764L-40 295.575L-9.72651 325.389L20.5517 295.575Z",
    fill: "url(#paint85_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.904 292.682L631.661 299.334L640.481 290.65L645.482 295.575L628.724 312.078L611.964 295.575L628.724 279.071L631.453 281.758L638.209 275.101L628.724 265.764L598.448 295.575L628.724 325.389L659 295.575L640.481 277.341L624.904 292.682Z",
    fill: "url(#paint86_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3457 325.389L91.6216 295.575L73.103 277.341L57.5256 292.682L64.2845 299.334L73.103 290.65L78.1038 295.575L61.3457 312.078L44.5853 295.575L61.3457 279.071L64.0741 281.758L70.8306 275.101L61.3457 265.764L31.0699 295.575L61.3457 325.389Z",
    fill: "url(#paint87_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.495 295.376L143.977 277.145L128.399 292.483L135.156 299.138L143.977 290.451L148.977 295.376L132.217 311.879L115.459 295.376L132.217 278.873L134.945 281.559L141.704 274.902L132.217 265.566L101.943 295.376L132.217 325.191L162.495 295.376Z",
    fill: "url(#paint88_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.369 295.575L214.85 277.341L199.273 292.682L206.029 299.334L214.85 290.65L219.851 295.575L203.09 312.078L186.33 295.575L203.09 279.071L205.819 281.758L212.578 275.101L203.09 265.764L172.817 295.575L203.09 325.389L233.369 295.575Z",
    fill: "url(#paint89_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.438 295.575L285.92 277.341L270.342 292.682L277.099 299.334L285.92 290.65L290.921 295.575L274.163 312.078L257.402 295.575L274.163 279.071L276.889 281.758L283.647 275.101L274.163 265.764L243.887 295.575L274.163 325.389L304.438 295.575Z",
    fill: "url(#paint90_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.312 295.376L356.793 277.145L341.216 292.483L347.973 299.138L356.793 290.451L361.794 295.376L345.034 311.879L328.273 295.376L345.034 278.873L347.762 281.559L354.521 274.902L345.034 265.566L314.76 295.376L345.034 325.191L375.312 295.376Z",
    fill: "url(#paint91_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.183 295.575L427.665 277.341L412.087 292.682L418.846 299.334L427.665 290.65L432.665 295.575L415.907 312.078L399.147 295.575L415.907 279.071L418.636 281.758L425.392 275.101L415.907 265.764L385.631 295.575L415.907 325.389L446.183 295.575Z",
    fill: "url(#paint92_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.255 295.575L498.737 277.341L483.159 292.682L489.916 299.334L498.737 290.65L503.738 295.575L486.977 312.078L470.219 295.575L486.977 279.071L489.705 281.758L496.464 275.101L486.977 265.764L456.704 295.575L486.977 325.389L517.255 295.575Z",
    fill: "url(#paint93_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.09 295.376L557.851 278.873L560.579 281.559L567.336 274.902L557.851 265.566L527.575 295.376L557.851 325.191L588.126 295.376L569.608 277.145L554.031 292.483L560.789 299.138L569.608 290.451L574.609 295.376L557.851 311.879L541.09 295.376Z",
    fill: "url(#paint94_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4215 363.909L55.6997 334.097L37.1812 315.863L21.6037 331.202L28.3603 337.857L37.1812 329.173L42.1819 334.097L25.4215 350.6L8.66343 334.097L25.4215 317.594L28.1498 320.28L34.9087 313.623L25.4215 304.284L-4.85198 334.097L25.4215 363.909Z",
    fill: "url(#paint95_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77 334.097L108.251 315.863L92.6736 331.202L99.4325 337.857L108.251 329.173L113.252 334.097L96.4937 350.6L79.7333 334.097L96.4937 317.594L99.2221 320.28L105.979 313.623L96.4937 304.284L66.2179 334.097L96.4937 363.909L126.77 334.097Z",
    fill: "url(#paint96_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.643 333.898L179.125 315.667L163.547 331.006L170.304 337.658L179.125 328.974L184.125 333.898L167.367 350.401L150.607 333.898L167.367 317.395L170.096 320.081L176.852 313.425L167.367 304.088L137.091 333.898L167.367 363.713L197.643 333.898Z",
    fill: "url(#paint97_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.517 334.097L249.998 315.863L234.421 331.202L241.177 337.857L249.998 329.173L254.999 334.097L238.238 350.6L221.48 334.097L238.238 317.594L240.967 320.28L247.726 313.623L238.238 304.284L207.965 334.097L238.238 363.909L268.517 334.097Z",
    fill: "url(#paint98_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.586 334.097L321.068 315.863L305.491 331.202L312.247 337.857L321.068 329.173L326.069 334.097L309.311 350.6L292.55 334.097L309.311 317.594L312.039 320.28L318.795 313.623L309.311 304.284L279.035 334.097L309.311 363.909L339.586 334.097Z",
    fill: "url(#paint99_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.46 333.898L391.941 315.667L376.364 331.006L383.121 337.658L391.941 328.974L396.942 333.898L380.182 350.401L363.424 333.898L380.182 317.395L382.91 320.081L389.669 313.425L380.182 304.088L349.908 333.898L380.182 363.713L410.46 333.898Z",
    fill: "url(#paint100_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.333 334.097L462.813 315.863L447.235 331.202L453.994 337.857L462.813 329.173L467.816 334.097L451.055 350.6L434.295 334.097L451.055 317.594L453.784 320.28L460.54 313.623L451.055 304.284L420.782 334.097L451.055 363.909L481.333 334.097Z",
    fill: "url(#paint101_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.403 334.097L533.885 315.863L518.307 331.202L525.064 337.857L533.885 329.173L538.886 334.097L522.125 350.6L505.367 334.097L522.125 317.594L524.854 320.28L531.612 313.623L522.125 304.284L491.852 334.097L522.125 363.909L552.403 334.097Z",
    fill: "url(#paint102_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.238 333.898L592.999 317.395L595.727 320.081L602.484 313.425L592.999 304.088L562.725 333.898L592.999 363.713L623.277 333.898L604.756 315.667L589.179 331.006L595.937 337.658L604.756 328.974L609.759 333.898L592.999 350.401L576.238 333.898Z",
    fill: "url(#paint103_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5517 372.713L2.03314 354.479L-13.5443 369.82L-6.78777 376.473L2.03314 367.788L7.03391 372.713L-9.72651 389.216L-26.4846 372.713L-9.72651 356.209L-6.99817 358.896L-0.2393 352.239L-9.72651 342.903L-40 372.713L-9.72651 402.527L20.5517 372.713Z",
    fill: "url(#paint104_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.904 369.82L631.661 376.473L640.481 367.788L645.482 372.713L628.724 389.216L611.964 372.713L628.724 356.209L631.453 358.896L638.209 352.239L628.724 342.903L598.448 372.713L628.724 402.527L659 372.713L640.481 354.479L624.904 369.82Z",
    fill: "url(#paint105_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3457 402.527L91.6216 372.713L73.103 354.479L57.5256 369.82L64.2845 376.473L73.103 367.788L78.1038 372.713L61.3457 389.216L44.5853 372.713L61.3457 356.209L64.0741 358.896L70.8306 352.239L61.3457 342.903L31.0699 372.713L61.3457 402.527Z",
    fill: "url(#paint106_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.495 372.514L143.977 354.283L128.399 369.621L135.156 376.276L143.977 367.59L148.977 372.514L132.217 389.017L115.459 372.514L132.217 356.011L134.945 358.697L141.704 352.04L132.217 342.704L101.943 372.514L132.217 402.329L162.495 372.514Z",
    fill: "url(#paint107_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.369 372.713L214.85 354.479L199.273 369.82L206.029 376.473L214.85 367.788L219.851 372.713L203.09 389.216L186.33 372.713L203.09 356.209L205.819 358.896L212.578 352.239L203.09 342.903L172.817 372.713L203.09 402.527L233.369 372.713Z",
    fill: "url(#paint108_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.438 372.713L285.92 354.479L270.342 369.82L277.099 376.473L285.92 367.788L290.921 372.713L274.163 389.216L257.402 372.713L274.163 356.209L276.889 358.896L283.647 352.239L274.163 342.903L243.887 372.713L274.163 402.527L304.438 372.713Z",
    fill: "url(#paint109_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.312 372.514L356.793 354.283L341.216 369.621L347.973 376.276L356.793 367.59L361.794 372.514L345.034 389.017L328.273 372.514L345.034 356.011L347.762 358.697L354.521 352.04L345.034 342.704L314.76 372.514L345.034 402.329L375.312 372.514Z",
    fill: "url(#paint110_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.183 372.713L427.665 354.479L412.087 369.82L418.846 376.473L427.665 367.788L432.665 372.713L415.907 389.216L399.147 372.713L415.907 356.209L418.636 358.896L425.392 352.239L415.907 342.903L385.631 372.713L415.907 402.527L446.183 372.713Z",
    fill: "url(#paint111_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.255 372.713L498.737 354.479L483.159 369.82L489.916 376.473L498.737 367.788L503.738 372.713L486.977 389.216L470.219 372.713L486.977 356.209L489.705 358.896L496.464 352.239L486.977 342.903L456.704 372.713L486.977 402.527L517.255 372.713Z",
    fill: "url(#paint112_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.09 372.514L557.851 356.011L560.579 358.697L567.336 352.04L557.851 342.704L527.575 372.514L557.851 402.329L588.126 372.514L569.608 354.283L554.031 369.621L560.789 376.276L569.608 367.59L574.609 372.514L557.851 389.017L541.09 372.514Z",
    fill: "url(#paint113_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4215 441.246L55.6997 411.434L37.1812 393.2L21.6037 408.539L28.3603 415.194L37.1812 406.507L42.1819 411.434L25.4215 427.935L8.66343 411.434L25.4215 394.93L28.1498 397.617L34.9087 390.96L25.4215 381.621L-4.85198 411.434L25.4215 441.246Z",
    fill: "url(#paint114_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.77 411.434L108.251 393.2L92.6736 408.539L99.4325 415.194L108.251 406.507L113.252 411.434L96.4937 427.935L79.7333 411.434L96.4937 394.93L99.2221 397.617L105.979 390.96L96.4937 381.621L66.2179 411.434L96.4937 441.246L126.77 411.434Z",
    fill: "url(#paint115_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.643 411.235L179.125 393.001L163.547 408.34L170.304 414.995L179.125 406.311L184.125 411.235L167.367 427.738L150.607 411.235L167.367 394.732L170.096 397.418L176.852 390.761L167.367 381.423L137.091 411.235L167.367 441.047L197.643 411.235Z",
    fill: "url(#paint116_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.517 411.434L249.998 393.2L234.421 408.539L241.177 415.194L249.998 406.507L254.999 411.434L238.238 427.935L221.48 411.434L238.238 394.93L240.967 397.617L247.726 390.96L238.238 381.621L207.965 411.434L238.238 441.246L268.517 411.434Z",
    fill: "url(#paint117_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.586 411.434L321.068 393.2L305.491 408.539L312.247 415.194L321.068 406.507L326.069 411.434L309.311 427.935L292.55 411.434L309.311 394.93L312.039 397.617L318.795 390.96L309.311 381.621L279.035 411.434L309.311 441.246L339.586 411.434Z",
    fill: "url(#paint118_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.46 411.235L391.941 393.001L376.364 408.34L383.121 414.995L391.941 406.311L396.942 411.235L380.182 427.738L363.424 411.235L380.182 394.732L382.91 397.418L389.669 390.761L380.182 381.423L349.908 411.235L380.182 441.047L410.46 411.235Z",
    fill: "url(#paint119_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.333 411.434L462.813 393.2L447.235 408.539L453.994 415.194L462.813 406.507L467.816 411.434L451.055 427.935L434.295 411.434L451.055 394.93L453.784 397.617L460.54 390.96L451.055 381.621L420.782 411.434L451.055 441.246L481.333 411.434Z",
    fill: "url(#paint120_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.403 411.434L533.885 393.2L518.307 408.539L525.064 415.194L533.885 406.507L538.886 411.434L522.125 427.935L505.367 411.434L522.125 394.93L524.854 397.617L531.612 390.96L522.125 381.621L491.852 411.434L522.125 441.246L552.403 411.434Z",
    fill: "url(#paint121_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.238 411.235L592.999 394.732L595.727 397.418L602.484 390.761L592.999 381.423L562.725 411.235L592.999 441.047L623.277 411.235L604.756 393.001L589.179 408.34L595.937 414.995L604.756 406.311L609.759 411.235L592.999 427.738L576.238 411.235Z",
    fill: "url(#paint122_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5517 450.049L2.03314 431.816L-13.5443 447.155L-6.78777 453.809L2.03314 445.125L7.03391 450.049L-9.72651 466.553L-26.4846 450.049L-9.72651 433.546L-6.99817 436.233L-0.2393 429.576L-9.72651 420.237L-40 450.049L-9.72651 479.862L20.5517 450.049Z",
    fill: "url(#paint123_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.904 447.155L631.661 453.809L640.481 445.125L645.482 450.049L628.724 466.553L611.964 450.049L628.724 433.546L631.453 436.233L638.209 429.576L628.724 420.237L598.448 450.049L628.724 479.862L659 450.049L640.481 431.816L624.904 447.155Z",
    fill: "url(#paint124_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6216 450.049L73.103 431.816L57.5256 447.155L64.2845 453.809L73.103 445.125L78.1038 450.049L61.3457 466.553L44.5853 450.049L61.3457 433.546L64.0741 436.233L70.8306 429.576L61.3457 420.237L31.0699 450.049L61.3457 479.862L91.6216 450.049Z",
    fill: "url(#paint125_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.495 449.851L143.977 431.62L128.399 446.958L135.156 453.611L143.977 444.926L148.977 449.851L132.217 466.354L115.459 449.851L132.217 433.348L134.945 436.034L141.704 429.377L132.217 420.041L101.943 449.851L132.217 479.666L162.495 449.851Z",
    fill: "url(#paint126_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.369 450.049L214.85 431.816L199.273 447.155L206.029 453.809L214.85 445.125L219.851 450.049L203.09 466.553L186.33 450.049L203.09 433.546L205.819 436.233L212.578 429.576L203.09 420.237L172.817 450.049L203.09 479.862L233.369 450.049Z",
    fill: "url(#paint127_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.438 450.049L285.92 431.816L270.342 447.155L277.099 453.809L285.92 445.125L290.921 450.049L274.163 466.553L257.402 450.049L274.163 433.546L276.889 436.233L283.647 429.576L274.163 420.237L243.887 450.049L274.163 479.862L304.438 450.049Z",
    fill: "url(#paint128_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.312 449.851L356.793 431.62L341.216 446.958L347.973 453.611L356.793 444.926L361.794 449.851L345.034 466.354L328.273 449.851L345.034 433.348L347.762 436.034L354.521 429.377L345.034 420.041L314.76 449.851L345.034 479.666L375.312 449.851Z",
    fill: "url(#paint129_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.183 450.049L427.665 431.816L412.087 447.155L418.846 453.809L427.665 445.125L432.665 450.049L415.907 466.553L399.147 450.049L415.907 433.546L418.636 436.233L425.392 429.576L415.907 420.237L385.631 450.049L415.907 479.862L446.183 450.049Z",
    fill: "url(#paint130_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.255 450.049L498.737 431.816L483.159 447.155L489.916 453.809L498.737 445.125L503.738 450.049L486.977 466.553L470.219 450.049L486.977 433.546L489.705 436.233L496.464 429.576L486.977 420.237L456.704 450.049L486.977 479.862L517.255 450.049Z",
    fill: "url(#paint131_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.126 449.851L569.608 431.62L554.031 446.958L560.789 453.611L569.608 444.926L574.609 449.851L557.851 466.354L541.09 449.851L557.851 433.348L560.579 436.034L567.336 429.377L557.851 420.041L527.575 449.851L557.851 479.666L588.126 449.851Z",
    fill: "url(#paint132_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1812 470.338L21.6037 485.677L28.3603 492.332L37.1812 483.647L42.1819 488.572L25.4215 505.075L8.66343 488.572L25.4215 472.069L28.1498 474.755L34.9087 468.098L25.4215 458.759L-4.85198 488.572L25.4215 518.384L55.6997 488.572L37.1812 470.338Z",
    fill: "url(#paint133_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.251 470.338L92.6736 485.677L99.4325 492.332L108.251 483.647L113.252 488.572L96.4937 505.075L79.7333 488.572L96.4937 472.069L99.2221 474.755L105.979 468.098L96.4937 458.759L66.2179 488.572L96.4937 518.384L126.77 488.572L108.251 470.338Z",
    fill: "url(#paint134_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.125 470.14L163.547 485.478L170.304 492.133L179.125 483.449L184.125 488.373L167.367 504.876L150.607 488.373L167.367 471.87L170.096 474.556L176.852 467.9L167.367 458.563L137.091 488.373L167.367 518.188L197.643 488.373L179.125 470.14Z",
    fill: "url(#paint135_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.998 470.338L234.421 485.677L241.177 492.332L249.998 483.647L254.999 488.572L238.238 505.075L221.48 488.572L238.238 472.069L240.967 474.755L247.726 468.098L238.238 458.759L207.965 488.572L238.238 518.384L268.517 488.572L249.998 470.338Z",
    fill: "url(#paint136_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.068 470.338L305.491 485.677L312.247 492.332L321.068 483.647L326.069 488.572L309.311 505.075L292.55 488.572L309.311 472.069L312.039 474.755L318.795 468.098L309.311 458.759L279.035 488.572L309.311 518.384L339.586 488.572L321.068 470.338Z",
    fill: "url(#paint137_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.941 470.14L376.364 485.478L383.121 492.133L391.941 483.449L396.942 488.373L380.182 504.876L363.424 488.373L380.182 471.87L382.91 474.556L389.669 467.9L380.182 458.563L349.908 488.373L380.182 518.188L410.46 488.373L391.941 470.14Z",
    fill: "url(#paint138_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.813 470.338L447.235 485.677L453.994 492.332L462.813 483.647L467.816 488.572L451.055 505.075L434.295 488.572L451.055 472.069L453.784 474.755L460.54 468.098L451.055 458.759L420.782 488.572L451.055 518.384L481.333 488.572L462.813 470.338Z",
    fill: "url(#paint139_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.885 470.338L518.307 485.677L525.064 492.332L533.885 483.647L538.886 488.572L522.125 505.075L505.367 488.572L522.125 472.069L524.854 474.755L531.612 468.098L522.125 458.759L491.852 488.572L522.125 518.384L552.403 488.572L533.885 470.338Z",
    fill: "url(#paint140_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.756 470.14L589.179 485.478L595.937 492.133L604.756 483.449L609.759 488.373L592.999 504.876L576.238 488.373L592.999 471.87L595.727 474.556L602.484 467.9L592.999 458.563L562.725 488.373L592.999 518.188L623.277 488.373L604.756 470.14Z",
    fill: "url(#paint141_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.5443 524.293L-6.78777 530.947L2.03314 522.263L7.03391 527.188L-9.72651 543.691L-26.4846 527.188L-9.72651 510.684L-6.99817 513.371L-0.2393 506.714L-9.72651 497.375L-40 527.188L-9.72651 557L20.5517 527.188L2.03314 508.954L-13.5443 524.293Z",
    fill: "url(#paint142_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.904 524.293L631.661 530.947L640.481 522.263L645.482 527.188L628.724 543.691L611.964 527.188L628.724 510.684L631.453 513.371L638.209 506.714L628.724 497.375L598.448 527.188L628.724 557L659 527.188L640.481 508.954L624.904 524.293Z",
    fill: "url(#paint143_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5256 524.293L64.2845 530.947L73.103 522.263L78.1038 527.188L61.3457 543.691L44.5853 527.188L61.3457 510.684L64.0741 513.371L70.8306 506.714L61.3457 497.375L31.0699 527.188L61.3457 557L91.6216 527.188L73.103 508.954L57.5256 524.293Z",
    fill: "url(#paint144_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.399 524.096L135.156 530.749L143.977 522.065L148.977 526.989L132.217 543.492L115.459 526.989L132.217 510.486L134.945 513.172L141.704 506.515L132.217 497.179L101.943 526.989L132.217 556.804L162.495 526.989L143.977 508.758L128.399 524.096Z",
    fill: "url(#paint145_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.273 524.293L206.029 530.947L214.85 522.263L219.851 527.188L203.09 543.691L186.33 527.188L203.09 510.684L205.819 513.371L212.578 506.714L203.09 497.375L172.817 527.188L203.09 557L233.369 527.188L214.85 508.954L199.273 524.293Z",
    fill: "url(#paint146_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.342 524.293L277.099 530.947L285.92 522.263L290.921 527.188L274.163 543.691L257.402 527.188L274.163 510.684L276.889 513.371L283.647 506.714L274.163 497.375L243.887 527.188L274.163 557L304.438 527.188L285.92 508.954L270.342 524.293Z",
    fill: "url(#paint147_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.216 524.096L347.973 530.749L356.793 522.065L361.794 526.989L345.034 543.492L328.273 526.989L345.034 510.486L347.762 513.172L354.521 506.515L345.034 497.179L314.76 526.989L345.034 556.804L375.312 526.989L356.793 508.758L341.216 524.096Z",
    fill: "url(#paint148_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.087 524.293L418.846 530.947L427.665 522.263L432.665 527.188L415.907 543.691L399.147 527.188L415.907 510.684L418.636 513.371L425.392 506.714L415.907 497.375L385.631 527.188L415.907 557L446.183 527.188L427.665 508.954L412.087 524.293Z",
    fill: "url(#paint149_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.159 524.293L489.916 530.947L498.737 522.263L503.738 527.188L486.977 543.691L470.219 527.188L486.977 510.684L489.705 513.371L496.464 506.714L486.977 497.375L456.704 527.188L486.977 557L517.255 527.188L498.737 508.954L483.159 524.293Z",
    fill: "url(#paint150_linear_224_767)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.031 524.096L560.789 530.749L569.608 522.065L574.609 526.989L557.851 543.492L541.09 526.989L557.851 510.486L560.579 513.172L567.336 506.515L557.851 497.179L527.575 526.989L557.851 556.804L588.126 526.989L569.608 508.758L554.031 524.096Z",
    fill: "url(#paint151_linear_224_767)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_224_767",
    x1: 164,
    y1: 268.5,
    x2: 144.5,
    y2: 4.94276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatewayPatternTop);
export default __webpack_public_path__ + "static/media/gatewayPatternTop.e9e124d9e8342360ba14b0f3a3cf115c.svg";
export { ForwardRef as ReactComponent };